import { Directive, ViewContainerRef } from '@angular/core';
/** ViewContainerDirective */
@Directive({
    selector: '[viewContainer]',
})
export class ViewContainerDirective {
   public constructor (public viewContainerRef: ViewContainerRef) { }
}
